import ExpoConstants from 'expo-constants';

const asRecord = (value: unknown): Record<string, unknown> | undefined =>
	typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : undefined;

const readString = (source: unknown, key: string): string | undefined => {
	const value = asRecord(source)?.[key];

	return typeof value === 'string' ? value : undefined;
};

const readStringArray = (source: unknown, key: string): string[] | undefined => {
	const value = asRecord(source)?.[key];

	if (!Array.isArray(value)) {
		return undefined;
	}

	const entries: unknown[] = value;
	const isStringArray = (candidates: unknown[]): candidates is string[] =>
		candidates.every((entry) => typeof entry === 'string');

	return isStringArray(entries) ? entries : undefined;
};

const extra = (): unknown => ExpoConstants.expoConfig?.extra;

export const environmentName = (): string | undefined => readString(extra(), 'environment');

export const apiUrl = (): string | undefined => readString(asRecord(extra())?.['api'], 'url');

export const apiToken = (): string | undefined => readString(asRecord(extra())?.['api'], 'token');

export const deeplinkHosts = (): string[] => readStringArray(extra(), 'deeplinkHosts') ?? [];

export const appStoreUrl = (): string | undefined => readString(extra(), 'appStoreUrl');

export const playStoreUrl = (): string | undefined => readString(extra(), 'playStoreUrl');

export const deeplinkDomainSuffix = (): string => readString(extra(), 'deeplinkDomainSuffix') ?? '';
